import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const convertKit = defineConnector({
  identifier: "convertKit",
  name: "ConvertKit",
  tagLine: "Email marketing for creators",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.convertkit\\.com/.*",
  auth: (app) =>
    queryAuth([{ name: "api_secret", value: app.secret.apiSecret }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [ConvertKit](https://app.convertkit.com/) and navigate to **Settings** → **Advanced** → **API**.\n\nCopy your **API Secret** (not the API Key) for full access to the API.",
        },
      ],
    },
    {
      title: "Enter your API secret",
      items: [
        {
          kind: "markdown",
          content: "Paste your API secret below.",
        },
        {
          kind: "input",
          label: "API secret",
          placeholder: "your-api-secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.convertkit.com/v3/account",
      expectedStatus: 200,
    }),
  },
});
